import get from 'lodash.get';

const getError = (state) => get(state, 'ws.saving.error', {});
export default getError;
